// extracted by mini-css-extract-plugin
export default {"time":"Clock_time__T1l43","wrapper":"Clock_wrapper__Ku6sC","time-tem":"Clock_time-tem__8M9ft"};